import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { AccountService } from '../../core/auth/account.service';
import { AppConfigService } from '../../core/config/app-config.service';
import { Account } from '../../core/user/account.model';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink],
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit {
  userName = '';

  constructor(
    private router: Router,
    public translateService: TranslateService,
    public accountService: AccountService,
    private appConfigService: AppConfigService,
  ) {}

  ngOnInit(): void {
    this.accountService.identity()
      .then((account: Account | null) => {
        if (account) {
          this.setUpTheUI(account);
        }
      })
      .catch(error => {
        console.error('LandingPageComponent: Error fetching identity', error);
      });
  }

  private setUpTheUI(user: Account): void {
    if (this.isAllowed(user)) {
      if (user.roleMemberOf?.includes('SYSTEM_AD')) {
        this.router.navigate(['../admin/user-management']);
      } else if (user.rootNodes?.length) {
        this.router.navigate(['../' + user.rootNodes[0]]);
      }
    } else {
      // User not allowed - show the landing page with username
      this.userName = user.login;
    }
  }

  private isAllowed(user: Account): boolean {
    // SYSTEM_AD users always allowed
    if (user.roleMemberOf?.length >= 1 && user.roleMemberOf.includes('SYSTEM_AD')) {
      return true;
    }
    // Users without roles or root nodes are not allowed
    if (!user.roleMemberOf?.length || !user.rootNodes?.length) {
      return false;
    }
    return true;
  }
}
